<template lang="pug">
  span.action(v-if="isEnabled && value === target")
    i.fa.fa-map-pin
  a.action.pull-right(v-else-if="isEnabled", href="#", title="ピンをつける", @click.prevent="pinning")
    i.fa.fa-map-pin
</template>

<script>
import RepositoryFactory from '@/repositories/RepositoryFactory'

const PinRepository = RepositoryFactory.get('pin')

export default {
  name: 'SidebarPin',
  props: {
    // 現在のピン位置
    value: { type: String, required: false, default: null },
    // 対象のピン名
    target: { type: String, required: true }
  },
  computed: {
    isEnabled () {
      return !this.isAgentPage && !this.isMgmt
    }
  },
  methods: {
    pinning () {
      const vm = this
      PinRepository.put(this.target)
        .then(function (response) {
          if (!vm.isApiSuccess(response)) return
          vm.showToast('サイドメニューのピンをつけ替えました。', { type: 'success' })
          vm.$emit('input', vm.target)
        })
        // エラー時処理
        .catch(function (error) {
          const message = vm.getErrorMessage(error) || 'サイドメニューのピンのつけ替えができませんでした。'
          vm.showToast(message, { type: 'danger' })
        })
    }
  }
}
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/organisms/TheSidebarPin.vue